import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { AnalysisButtons } from './analysisButtons'
import { SensorialHeading } from './sensorialHeading'
import { QualityAnalysisList } from './qualityAnalysisList'
import { getAnalysisResults } from '../../common/apis'
import { StoppedLineModal } from './stoppedLineModal'
import { ParamsContext } from '../qualityMonitoring'
import { liveHeaderHeight } from '../../common/utils'
import { breadCrumbHeight } from '../breadCrumb'

interface IProps {
    setSelectedAnalysis: Dispatch<SetStateAction<AnalysisEvent>>
}

export const SensorialTabContext = React.createContext<Dispatch<SetStateAction<boolean>>>(null)

export function SensorialTab({ setSelectedAnalysis }: IProps): JSX.Element {
    const urlParams = useContext(ParamsContext)
    const [analysisResults, setAnalysisResults] = useState<AnalysisEvent[]>([])
    const [analysisResultsWithoutStoppedLine, setAnalysisResultsWithoutStoppedLine] = useState<AnalysisEvent[]>([])
    const [actionPlansStatus, setActionPlansStatus] = useState<boolean[]>([])
    const [selectedStoppedLine, setSelectedStoppedLine] = useState<StoppedLineEvent>()
    const [updateList, setUpdateList] = useState(true)
    const [selectedSpan, setSelectedSpan] = useState<string>('last 24 hours')
    const [isLoadingResults, setIsLoadingResults] = useState<boolean>(true)

    useEffect(() => {
        getAnalysisResults(urlParams.split('/'), selectedSpan)
            .then((response: AnalysisEvent[]) => {
                setAnalysisResults(response)
                setAnalysisResultsWithoutStoppedLine(response.filter(analysis => analysis.sku))
                setActionPlansStatus(getActionPlansPendingStatus(response))
                setIsLoadingResults(false)
            })
            .catch(error => console.log(error))
        setUpdateList(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [urlParams, updateList, selectedSpan])

    function getActionPlansPendingStatus(analysisResults: AnalysisEvent[]): boolean[] {
        return analysisResults.reduce((acc, analysis) => {
            analysis.actionPlans?.forEach(plan => {
                acc.push(plan.planStatus)
            })

            return acc
        }, [])
    }

    return (
        <StyledSensorialTab>
            <SensorialHeading
                lastAnalysisTimestamp={analysisResultsWithoutStoppedLine[0]?.createdAt}
                lastResult={analysisResultsWithoutStoppedLine[0]?.finalScore}
                actionPlansStatus={actionPlansStatus}
            />
            <SensorialTabContext.Provider value={setUpdateList}>
                <AnalysisButtons />
            </SensorialTabContext.Provider>
            <span className="sensorialView--devider" />
            <QualityAnalysisList
                analysisResults={analysisResults}
                setSelectedAnalysis={setSelectedAnalysis}
                setSelectedStoppedLine={setSelectedStoppedLine}
                selectedSpan={selectedSpan}
                setSelectedSpan={setSelectedSpan}
                isLoadingResults={isLoadingResults}
            />
            <StoppedLineModal
                showModal={!!selectedStoppedLine}
                setShowModal={setSelectedStoppedLine}
                selectedStoppedLine={selectedStoppedLine}
            />
        </StyledSensorialTab>
    )
}

const topDeduction = liveHeaderHeight + breadCrumbHeight * 2

const StyledSensorialTab = styled.section`
    display: flex;
    flex-direction: column;
    grid-row-gap: 32px;
    padding: 25px 80px 0 40px;
    height: calc(100vh - ${topDeduction}px);
    .sensorialView {
        &--devider {
            height: 1px;
            background: ${({ theme }) => theme['gray-300']};
        }
        &--list {
            background: yellow;
        }
    }
`
